import AppLoggedOut from './LoggedOut'

function App () {
  return (<AppLoggedOut />)
}

export default App
